// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_AMBASSADOR_TAG = "ambas\u00e1dorka";
export const CONTEST_FINISHED_TAG = "s\u00fa\u0165a\u017e ukon\u010den\u00e1";
